<template>
  <div class="background">
    <v-container fluid fill-height>
      <v-row dense justify="center" align="center">
        <v-col cols="12" sm="8" md="4">
          <v-card
            style="
              background-color: #fcfcfd;
              border-radius: 10px;
              padding: 30px !important;
            "
          >
            <v-card-title
              class="d-flex align-center justify-center loginImages"
            >
              <v-img :src="titleImage" contain height="270"> </v-img>
            </v-card-title>
            <v-card-text elevation="0" class="m-0 p-0">
              <v-row dense align="center" justify="center">
                <v-img max-width="80" src="@/assets/icons/email.svg"></v-img>
              </v-row>
              <v-row align="center" justify="center">
                <h3 style="color: #8c1843; font-size: 23px">
                  Confirme seu e-mail
                </h3>
              </v-row>
              <v-row justify="center" class="mt-10">
                <span class="body-text-regular">
                  Enviamos um e-mail de confirmação de cadastro! <br />Verifique
                  sua caixa de mensagens para continuar!
                </span>
              </v-row>
              <v-row align="center" justify="center" class="mt-10">
                <div class="fill-width">
                  <v-btn
                    color="#B51F57"
                    class="white--text fill-width"
                    x-large
                    @click="returnToHome"
                  >
                    Ir para login
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
            <v-card-actions
              class="d-flex align-center justify-center flex-column"
            >
              <div>
                <CopyRight />
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import CopyRight from "@/components/CopyRight.vue";
export default {
  components: {
    CopyRight,
  },
  computed: {
    titleImage() {
      return this.module === "customer"
        ? require("@/assets/images/connect/customer/connect-logo.webp")
        : require("@/assets/images/connect/partner/connect-logo.webp");
    },
  },
  props: {
    module: {
      type: String,
    },
  },
  methods: {
    returnToHome() {
      localStorage.setItem(
        "module",
        this.module === "customer" ? "aluno" : "professor"
      );
      this.$router.push({
        path: "/connect",
      });
    },
  },
};
</script>
<style scoped>
.background {
  background-image: url("../../assets/images/connect/customer/background-min.webp");
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
}

.primary900 {
  color: var(--dk-pink-deep, #6b1233);
}
</style>
